import * as React from 'react';
import axios from 'axios';
import { Image } from 'modules';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'react-bootstrap';
import { notifyFailed, notifySuccess } from 'helpers/notify';
import './style.scss';

interface ImageUploadProps {
  name: string;
  value?: string | undefined;
  buttonLabel?: string;
  uploadURL?: string;
  uploadData?: any;
  multiple?: boolean;
  disabled?: boolean;
  onChange?: (e: any) => void;
  onBlur?: () => void;
}

const ImageUpload = ({
  name,
  value,
  buttonLabel,
  uploadData,
  multiple,
  disabled,
  onChange,
  onBlur,
  ...props
}: ImageUploadProps) => {
  const { t } = useTranslation();
  const [uploading, setUploading] = React.useState<boolean>(false);

  const clearFile = () => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: null,
        },
      });
    }
  };

  const uploadFile = async (file: any) => {
    const data = new FormData();
    data.append('file', file);

    if (uploadData) {
      Object.keys(uploadData).forEach((k: string) => {
        data.append(k, uploadData[k]);
      });
    }

    const uploadURL = props.uploadURL || process.env.REACT_APP_API_URL + '/image/upload';
    const result = await axios
      .post(uploadURL, data)
      .then((res) => res.data)
      .then((image) => {
        notifySuccess(t('FORM.IMAGE_UPLOADED'));
        return image;
      })
      .catch(() => {
        // console.log('upload failed', error);
        // todo: odeslání notifikace o chybě na můj email, nebo do nějakého online nástroje
        notifyFailed(t('FORM.IMAGE_CANNOT_BE_UPLOADED'));
      });

    return result;
  };

  /**
   * Uložení vybraných obrázků
   *
   * @param e
   */
  const uploadFiles = async (e: any) => {
    if (e.target.files) {
      setUploading(true);

      const fileList: Array<any> = [];
      for (let i = 0; i < e.target.files.length; i++) {
        fileList.push(e.target.files[i]);
      }

      const uploadResults: Array<any> = [];

      await fileList.reduce((promise: Promise<any>, file: any) => {
        return promise.then(
          (acc: any) =>
            new Promise(async (resolve) => {
              // upload souboru
              const uploadResult = await uploadFile(file);
              if (uploadResult) {
                uploadResults.push(uploadResult);
              }

              resolve(acc);
            }),
        );
      }, Promise.resolve({}));

      if (onChange) {
        onChange({
          target: {
            name,
            value: uploadResults,
          },
        });
      }

      setUploading(false);
    }
  };

  return (
    <div className="fileInput">
      {value && (
        <div className="image">
          <Image src={value} size={300} />
          {disabled !== true && (
            <span className="close" onClick={clearFile}>
              ×
            </span>
          )}
        </div>
      )}
      <span className={`btn btn-primary btn-file ${disabled === true || uploading ? ' disabled' : ''}`}>
        {uploading && <Spinner size="sm" animation="border" />}
        <span>{buttonLabel || t('FORM.' + (!value ? 'SELECT_IMAGE' : 'CHANGE_IMAGE'))}</span>
        <input
          type="file"
          className="btn btn-xs"
          name={name}
          disabled={disabled === true || uploading}
          multiple={multiple === true}
          onChange={uploadFiles}
          onBlur={onBlur}
        />
      </span>
    </div>
  );
};

export default ImageUpload;
